const initialState = window.Config.blog

export default (state = initialState, action) => {
  return state
}
